import { Yekan } from '@/pages/_app';
import React from 'react';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    h1: React.CSSProperties;
    h2: React.CSSProperties;
    h3: React.CSSProperties;
    h4: React.CSSProperties;
    h5: React.CSSProperties;
    h6: React.CSSProperties;
    title: React.CSSProperties;
    subtitle: React.CSSProperties;
    body1: React.CSSProperties;
    body2: React.CSSProperties;
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h1: React.CSSProperties;
    h2: React.CSSProperties;
    h3: React.CSSProperties;
    h4: React.CSSProperties;
    h5: React.CSSProperties;
    h6: React.CSSProperties;
    title: React.CSSProperties;
    subtitle: React.CSSProperties;
    body1: React.CSSProperties;
    body2: React.CSSProperties;
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h1: true;
    h2: true;
    h3: true;
    h4: true;
    h5: true;
    h6: true;
    title: true;
    subtitle: true;
    body1: true;
    body2: true;
    body3: true;
    body4: true;
    body5: true;
  }
}

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        '& a': {
          position: 'relative',
          color: theme.palette.primary.A100,
          textDecoration: 'none'
        },
        '& a:hover': {
          color: theme.palette.primary.A80
        },
        '& a:hover:before': {
          borderBottomColor: theme.palette.primary.A80
        },
        '& a:before': {
          left: 0,
          right: 0,
          bottom: 0,
          content: "''",
          position: 'absolute',
          borderBottom: `1px dotted ${theme.palette.primary.A100}`
        }
      })
    },
    defaultProps: {
      variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        title: 'h6',
        subtitle: 'span',
        body1: 'p',
        body2: 'p',
        body3: 'span',
        body4: 'span',
        body45: 'span'
      }
    }
  },
  typography: {
    fontFamily: Yekan.style.fontFamily,
    h1: {
      fontSize: '48px',
      lineHeight: '72px'
    },
    h2: {
      fontSize: '40px',
      lineHeight: '64px'
    },
    h3: {
      fontSize: '32px',
      lineHeight: '56px'
    },
    h4: {
      fontSize: '28px',
      lineHeight: '44px'
    },
    h5: {
      fontSize: '24px',
      lineHeight: '40px'
    },
    h6: {
      fontSize: '22px',
      lineHeight: '38px'
    },
    title: {
      fontSize: '20px',
      lineHeight: '32px',
      fontFamily: Yekan.style.fontFamily
    },
    subtitle: {
      fontSize: '18px',
      lineHeight: '32px',
      fontFamily: Yekan.style.fontFamily
    },
    button: {
      fontSize: '16px',
      lineHeight: '24px',
      fontFamily: Yekan.style.fontFamily
    },
    body1: {
      fontSize: '16px',
      lineHeight: '28px'
    },
    body2: {
      fontSize: '14px',
      lineHeight: '24px'
    },
    body3: {
      fontSize: '12px',
      lineHeight: '20px',
      fontFamily: Yekan.style.fontFamily
    },
    body4: {
      fontSize: '10px',
      lineHeight: '16px',
      fontFamily: Yekan.style.fontFamily
    },
    body5: {
      fontSize: '12px',
      lineHeight: '24px',
      fontFamily: Yekan.style.fontFamily
    }
  }
};
